import { IoBookmarkOutline } from 'react-icons/io5';

import { Group, ThemeIcon } from '@mantine/core';

import { CheckboxField } from 'components/forms/fields/CheckboxField';

const CreateAccountField = () => (
    <Group
        p="sm"
        gap="sm"
        wrap="nowrap"
        align="flex-start"
        bg="gray.1"
        style={{ borderRadius: 'var(--mantine-radius-md)' }}
    >
        <ThemeIcon variant="white" color="#5146ff" size="lg" radius="md">
            <IoBookmarkOutline size={16} />
        </ThemeIcon>
        <CheckboxField
            flex={1}
            name="createAccount"
            labelPosition="left"
            color="#5146ff"
            label="Create a free account"
            description="Keep everything you scan and your notes in one place. We will email you a sign-in link."
            styles={{
                body: { justifyContent: 'space-between' },
                labelWrapper: { flex: 1 },
                label: { fontWeight: 600, paddingInlineStart: 0 },
                description: { paddingInlineStart: 0 },
            }}
        />
    </Group>
);

export { CreateAccountField };
